import { render, staticRenderFns } from "./ShadowChangeDiff.vue?vue&type=template&id=322c3882&scoped=true"
import script from "./ShadowChangeDiff.vue?vue&type=script&lang=js"
export * from "./ShadowChangeDiff.vue?vue&type=script&lang=js"
import style0 from "./ShadowChangeDiff.vue?vue&type=style&index=0&id=322c3882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c3882",
  null
  
)

export default component.exports